module.exports = __webpack_public_path__ + "media/music/piano_chords_0-6505434b.mp3";